import type { QueryOptions } from '@tanstack/react-query';

import { http } from '@/api/instance';
import { getQueryParameters } from '@/api/query';

export const invoiceAPI = {
  receipt: {
    list: ({ ...params }: Record<string, string | number>) =>
      http.get<ListResultsPageSize<Receipt>>('/api/info/receipts', { params }).then(({ data }) => data),
    create: (data: ReceiptFormPayload) => http.post<unknown>(`/api/add/receipts`, { data }),
    update: (id: number | null, data: ReceiptFormPayload) => http.put<unknown>(`/api/edit/receipts/${id}`, { data }),
    delete: (id: number | string) => http.delete<unknown>(`/api/delete/receipts/${id}`),
    detail: (id: number | string) => http.get<Account>(`/api/info/accounts/${id}`).then(({ data }) => data),
  },
  payment: {
    list: ({ ...params }: Record<string, string | number>) =>
      http.get<ListResultsPageSize<Payment>>('/api/info/payments', { params }).then(({ data }) => data),
    create: (data: PaymentFormPayload) => http.post<unknown>(`/api/add/payments`, { data }),
    update: (id: number | null, data: PaymentFormPayload) => http.put<unknown>(`/api/edit/payments/${id}`, { data }),
    delete: (id: number | string) => http.delete<unknown>(`/api/delete/payments/${id}`),
  },
};

export const invoiceQuery = {
  receiptList: (params: QueryParams<Partial<SearchFormData>>) => {
    return {
      queryKey: ['GetReceiptList', params] as const,
      queryFn: () => invoiceAPI.receipt.list(getQueryParameters(params)),
    } as const satisfies QueryOptions;
  },
  paymentsList: (params: QueryParams<Partial<SearchFormData>>) =>
    ({
      queryKey: ['GetPaymentList', params] as const,
      queryFn: () => invoiceAPI.payment.list(getQueryParameters(params)),
    }) as const satisfies QueryOptions,
};
